<template>
  <div :class="$store.state.screenMode === 'dark' ? 'dark' : ''">
    <a
      :href="$store.state.routing.yungoSite"
      target="_blank"
      class="text-center fixed-bottom"
      id="poweredby"
      >powered by
      <img
        v-if="$store.state.screenMode === 'dark'"
        class="mt-auto mb-auto"
        src="@/assets/alleen-y-white.png"
        alt="yungo logo"
      />
      <img
        v-else
        class="mt-auto mb-auto"
        src="@/assets/alleen-y.png"
        alt="yungo logo"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: "CenteredYungoFooter",
};
</script>

<style scoped>
.dark #poweredby:hover {
  color: #6b539a !important;
}

#poweredby:hover {
  color: var(--yungo-primary-btn-hover) !important;
  text-decoration: none;
}

#poweredby {
  color: var(--yungo-main-color) !important;
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 12px;
  margin-top: -3%;
}

#poweredby img {
  margin-left: 2px;
  height: 22px;
  width: auto;
  margin-top: -4px !important;
}

@media only screen and (max-width: 600px) {
  .fixed-bottom {
    position: inherit;
    right: inherit;
    bottom: inherit;
    left: inherit;
  }

  #poweredby {
    display: none;
    /* position: relative;
    padding-top: 5px;
    margin: auto;
    display: block; */
  }
}
</style>